import { useStressAssessmentRoleSelect } from './hooks';
import { StressAssessmentRoleSelectPresentation } from './presentations';

export const StressAssessmentRoleSelect: React.FC = () => {
  const {
    state: { selectedRole },
    actions: { handleRoleChange, handleSubmit },
  } = useStressAssessmentRoleSelect();

  return (
    <StressAssessmentRoleSelectPresentation
      selectedRole={selectedRole}
      onRoleChange={handleRoleChange}
      onSubmit={handleSubmit}
    />
  );
};
